<template>
  <b-list-group>
    <b-list-group-item class="d-flex justify-content-between align-items-center">
      <span>Apple store</span>
      <b-link
        target="_blank"
        href="https://www.apple.com/legal/privacy/data/en/appstore/"
        variant="primary"
      >
        {{ i18n.t('privacy-policy') }}
      </b-link>
    </b-list-group-item>
    <b-list-group-item class="d-flex justify-content-between align-items-center">
      <span>Stripe</span>
      <b-link
        target="_blank"
        href="https://stripe.com/en-cz/privacy"
        variant="primary"
      >
        {{ i18n.t('privacy-policy') }}
      </b-link>
    </b-list-group-item>
    <b-list-group-item class="d-flex justify-content-between align-items-center">
      <span>render.com</span>
      <b-link
        target="_blank"
        href="https://render.com/privacy"
        variant="primary"
      >
        {{ i18n.t('privacy-policy') }}
      </b-link>
    </b-list-group-item>
    <b-list-group-item class="d-flex justify-content-between align-items-center">
      <span>Yandex metrica</span>
      <b-link
        target="_blank"
        href="https://yandex.ru/legal/metrica_mobile_agreement/?lang=en"
        variant="primary"
      >
        {{ i18n.t('privacy-policy') }}
      </b-link>
    </b-list-group-item>
    <b-list-group-item class="d-flex justify-content-between align-items-center">
      <span>Google analytics</span>
      <b-link
        target="_blank"
        href="https://policies.google.com/privacy?hl=en"
        variant="primary"
      >
        {{ i18n.t('privacy-policy') }}
      </b-link>
    </b-list-group-item>
    <b-list-group-item class="d-flex justify-content-between align-items-center">
      <span>Google Cloud and Google play</span>
      <b-link
        target="_blank"
        href="https://policies.google.com/privacy"
        variant="primary"
      >
        {{ i18n.t('privacy-policy') }}
      </b-link>
    </b-list-group-item>
  </b-list-group>
</template>

<script>
import { BLink, BListGroup, BListGroupItem } from 'bootstrap-vue'
import i18n from '@/libs/i18n'

export default {
  name: 'TablePartners',
  components: { BLink, BListGroup, BListGroupItem },
  data() {
    return {
      i18n,
    }
  }
}
</script>

<style scoped>

</style>
